
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { BreakpointOptions } from "@/types/controls";

@Component({
  components: {}
})
export default class ElementStudioBreakpointOptions extends Vue {
  @Prop()
  value!: BreakpointOptions;

  updateMultiple(multiple: boolean) {
    const newBreakpointOptions = {
      ...this.value,
      multiple
    };
    this.emit(newBreakpointOptions);
  }

  updateEnableNever(enableNever: boolean) {
    const newBreakpointOptions = {
      ...this.value,
      enableNever
    };
    this.emit(newBreakpointOptions);
  }

  emit(breakpointOptions: BreakpointOptions | undefined) {
    this.$emit("input", breakpointOptions);
  }
}
